import script from "./HealthSquares.vue?vue&type=script&setup=true&lang=js"
export * from "./HealthSquares.vue?vue&type=script&setup=true&lang=js"

import "./HealthSquares.vue?vue&type=style&index=0&id=f57bb0ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f57bb0ae"]])

export default __exports__